import { useEffect, useState } from "react";
import { Icon } from "@iconify/react";

// @material-ui core components
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";

// Arakan components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";

// Settings page components
import FormField from "components/FormField";
import i18n from "i18n";

import dayjs from "dayjs";
import IconPicker from "components/IconPicker";
import { Switch } from "@mui/material";

function Price({
  changeHandler,
  info,
  setErrors,
  errors,
  notification,
  setNotification,
  autoSwitchChangeHandler,
  donationDefaultValues,
}) {
  const { t } = i18n;
  const [inputs, setInputs] = useState([
    {
      key: "",
    },
  ]);

  const handleAddInput = () => {
    setInputs([
      ...inputs,
      {
        key: "",
      },
    ]);
    createTxt([
      ...inputs,
      {
        key: "",
      },
    ]);
  };

  useEffect(() => {
    donationDefaultValues.length > 0 && setInputs(donationDefaultValues);
  }, [donationDefaultValues]);

  const createTxt = (onChangeValue) => {
    let txt = "";
    onChangeValue.forEach((element, index) => {
      txt += element.key;
      if (index !== onChangeValue.length - 1) txt += "__";
    });
    changeHandler({
      target: { name: "donation_default_values", value: txt },
    });
  };

  const handleChange = (name, index, v) => {
    let onChangeValue = [...inputs];
    onChangeValue[index][name] = v;
    setInputs(onChangeValue);
    createTxt(onChangeValue);
  };

  const handleDeleteInput = (index) => {
    const newArray = [...inputs];
    newArray.splice(index, 1);
    setInputs(newArray);
    createTxt(newArray);
  };

  const formatForInput = (date) => {
    if (!date) return "";
    return dayjs(date).format("YYYY-MM-DDTHH:mm");
  };

  const parseFromInput = (value) => {
    return value ? dayjs(value) : null;
  };

  // Handle icon change
  const handleIconChange = (iconValue) => {
    changeHandler({
      target: { name: "icon_name", value: iconValue },
    });
  };

  return (
    <Card id="basic-info" sx={{ overflow: "visible" }}>
      <MDBox p={3}>
        <MDTypography variant="h5">بيانات التكلفة</MDTypography>
      </MDBox>
      <MDBox pb={3} px={3}>
        <Grid container spacing={3}>
          <Grid item xs={12} lg={12}>
            <MDBox display="flex" alignItems="center" mb={0.5} ml={-1.5}>
              <MDBox mt={0.5}>
                <Switch
                  name="status"
                  checked={info.status === "published" ? true : false}
                  onChange={() =>
                    autoSwitchChangeHandler(
                      "status",
                      info.status === "published" ? "draft" : "published",
                    )
                  }
                />
              </MDBox>
              <MDBox width="80%" ml={0.5}>
                <MDTypography
                  variant="button"
                  fontWeight="regular"
                  color="text"
                >
                  الحالة
                </MDTypography>
              </MDBox>
            </MDBox>
          </Grid>
          <Grid item xs={12} lg={12}>
            <FormField
              onChange={changeHandler}
              variant="outlined"
              type="number"
              label={t("cost")}
              name="cost"
              value={info.cost}
              placeholder="cost"
              error={errors.cost}
            />
          </Grid>
          <Grid item xs={12} lg={6}>
            <FormField
              onChange={changeHandler}
              variant="outlined"
              type="number"
              label={"التكلفة تبدأ من"}
              name="donation_begin_from"
              value={info?.donation_begin_from}
              placeholder="donation_begin_from"
              error={errors?.donation_begin_from}
            />
          </Grid>
          <Grid item xs={12} lg={6}>
            <FormField
              onChange={changeHandler}
              variant="outlined"
              type="number"
              label={"عدد المتبرعين يبدأ من"}
              name="num_of_donors_begin_from"
              value={info?.num_of_donors_begin_from}
              placeholder="num_of_donors_begin_from"
              error={errors?.num_of_donors_begin_from}
            />
          </Grid>
          <Grid item xs={12}>
            <FormField
              label="بداية النشر"
              type="datetime-local"
              name="date_begin"
              value={formatForInput(info?.date_begin)}
              onChange={(e) =>
                changeHandler({
                  target: {
                    name: "date_begin",
                    value: parseFromInput(e.target.value),
                  },
                })
              }
              error={!!errors?.date_begin}
              variant="outlined"
              fullWidth
              InputLabelProps={{
                shrink: true,
              }}
              sx={{
                backgroundColor: "#ffffff",
                "& .MuiOutlinedInput-root": {
                  "&.Mui-error fieldset": {
                    borderColor: "red !important",
                  },
                },
              }}
            />
          </Grid>
          <Grid item xs={12}>
            <FormField
              label="نهاية النشر"
              type="datetime-local"
              name="date_end"
              value={formatForInput(info?.date_end)}
              onChange={(e) =>
                changeHandler({
                  target: {
                    name: "date_end",
                    value: parseFromInput(e.target.value),
                  },
                })
              }
              error={!!errors?.date_end}
              variant="outlined"
              fullWidth
              InputLabelProps={{
                shrink: true,
              }}
              sx={{
                backgroundColor: "#ffffff",
                "& .MuiOutlinedInput-root": {
                  "&.Mui-error fieldset": {
                    borderColor: "red !important",
                  },
                },
              }}
            />
          </Grid>

          {/* Icon Picker Section */}
          {/* <Grid item xs={12}>
            <MDBox mb={2}>
              <MDTypography variant="body2" fontWeight="medium" gutterBottom>
                أيقونة المشروع
              </MDTypography>
              <IconPicker
                value={info?.icon_name || ""}
                onChange={(iconValue) => {
                  changeHandler({
                    target: { name: "icon_name", value: iconValue },
                  });
                }}
                label="اختر أيقونة للمشروع"
                error={errors?.icon_name}
                helperText={errors?.icon_name}
              />
            </MDBox>

            {info?.icon_name && (
              <MDBox mt={2} p={2} bgcolor="grey.100" borderRadius="1px">
                <MDTypography variant="body2" fontWeight="medium" gutterBottom>
                  معاينة الأيقونة:
                </MDTypography>
                <MDBox display="flex" alignItems="center" gap={2}>
                  <Icon icon={info.icon_name} width={32} height={32} />
                  <MDTypography variant="body2" color="secondary">
                    {info.icon_name}
                  </MDTypography>
                </MDBox>
              </MDBox>
            )}
          </Grid> */}

          {/*  */}
          <Grid item xs={12} lg={12}>
            <FormField
              onChange={changeHandler}
              variant="outlined"
              type="number"
              label="قيمة التبرع الإفتراضية"
              name="donation_default_value"
              value={info.donation_default_value || ""}
              placeholder="donation_default_value"
              error={errors.donation_default_value}
            />
          </Grid>
          <Grid item xs={12} lg={12}>
            <FormField
              onChange={changeHandler}
              variant="outlined"
              type="number"
              label="معدل  عملات التبرع "
              name="donation_default_rate"
              value={info.donation_default_rate || ""}
              placeholder="donation_default_rate"
              error={errors.donation_default_rate}
            />
          </Grid>
          <Grid item xs={12}>
            {inputs.map((item, index) => (
              <MDBox
                display="flex"
                flexDirection="row"
                justifyContent="space-between" // Optional: adjust column spacing
                key={index}
                py={2}
              >
                <MDBox bgcolor="lightblue">
                  <FormField
                    label="قيمة التبرع المقترحة"
                    placeholder=""
                    name="key"
                    onChange={(event) =>
                      handleChange("key", index, event.target.value)
                    }
                    value={item.key}
                    error={errors?.donation_default_values}
                  />
                </MDBox>
                <MDBox bgcolor="lightblue">
                  {inputs.length > 1 && (
                    <MDButton onClick={() => handleDeleteInput(index)}>
                      -
                    </MDButton>
                  )}
                </MDBox>
                <MDBox bgcolor="lightblue">
                  {index === inputs.length - 1 && (
                    <MDButton onClick={() => handleAddInput()}>+</MDButton>
                  )}
                </MDBox>
              </MDBox>
            ))}
          </Grid>
        </Grid>
      </MDBox>
    </Card>
  );
}

export default Price;
